export default __webpack_public_path__ + "static/media/CarWrappingPageLocation.ad459c27.webp";